import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep2_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F34.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame34() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
        return (
            <div className="F34_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F34_entryBox">
                    <div className="F34_paragraph">
                        {language === 'english' ?
                            <p className="F34_paragraphEnglish">Still in the back of her mind, Saira is thinking what if her periods had come in school. How could she have better prepared for this.</p>
                            :
                            <p className="F34_paragraphUrdu">سائرہ ابھی بھی اس غور و فکر میں ہے کہ اگر اس کو ماہواری اسکول کے دوران آتی تو وہ اس کے لئے کیسے تیاری کر سکتی تھی۔</p>
                        }
                    </div>

                    <div className="F34_timeline">
                        <div className='F34_timelineBar'>
                            <div className='F34_timelineFill'></div>
                            <span className='F34_timelineText'>9/19</span>
                        </div>
                    </div>

                    <div className="F34_nextFrames">
                        <div className="F34_nextFrame1"></div>
                        <div className="F34_nextFrame2"></div>
                        <div className="F34_nextFrame3"></div>
                    </div>

                    <div className='F34_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep2_lastVisitFrame(9)) }} className='F34_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
}

export default Frame34;